module.exports = __webpack_public_path__ + "assets/6d83a0b7c5c7f63fec70f37097e98079.png";